<template>
<div>
    <button @click="openDataBase()">Open Database</button>
    <button @click="insertData()">Insert data</button>
    <button @click="readData()">Read data</button>
    <button @click="findData()">Find data</button>
    <p>{{id}}</p>
    <h1>Hallo Welt 3000</h1>
</div>
</template>
<script>
import { openDB } from 'idb';
export default {
name: 'test',
data: function(){
    return{
                id: 1
    }

},
methods: {
    openDataBase: async function(){
        window.console.log('openDataBase');
        openDB('db1', 1, {
            upgrade(db) {
                db.createObjectStore('store1', { keyPath: 'id' });
                db.createObjectStore('store2', { autoIncrement: true });
            },
        });
    },

    insertData: async function demo2() {

        const db1 = await openDB('db1', );
        // db1.add('store1', 'hello again', 'message1')
        db1.add('store1',  {id: this.id, message: 'message'})
        .then(result => {
            window.console.log('success!', result);
        })
        .catch(err => {
            window.console.error('error: ', err);
        });
        db1.add('store2', true);

        this.id++;
        db1.close();
    },

    readData: async function demo5() {
        const db1 = await openDB('db1', );

// retrieve all:
db1.getAll('store1').then(window.console.log);
// count the total number of items in a store:
db1.count('store1').then(window.console.log);
// get all keys:
db1.getAllKeys('store1').then(window.console.log);
},

// demo16: loop over the store with a cursor
findData: async function demo16() {
  const db1 = await openDB('db1', );
  // open a 'readonly' transaction:
  let store = db1.transaction('store1').store;
  // create a cursor, inspect where it's pointing at:
  let cursor = await store.openCursor();
  window.console.log('cursor.key: ', cursor.key);
  window.console.log('cursor.value: ', cursor.value);
  // move to next position:
  cursor = await cursor.continue();
  // inspect the new position:
  window.console.log('cursor.key: ', cursor.key);
  window.console.log('cursor.value: ', cursor.value);

  // keep moving until the end of the store
  // look for cats with strength and speed both greater than 8
  // while (true) {
  //   const { strength, speed } = cursor.value;
  //   if (strength >= 8 && speed >= 8) {
  //     window.console.log('found a good cat! ', cursor.value);
  //   }
  //   cursor = await cursor.continue();
  //   if (!cursor) break;
  // }
  db1.close();
}


}
}
</script>
